// extracted by mini-css-extract-plugin
module.exports = {"guideContainer":"_1mDph","sanjiao":"_3lytL","textContainer":"_3DeTI","disappearContainer":"qoAyK"};